export default {
  'header.menu.home': 'Trang chủ',
  'header.menu.about': 'Giới thiệu',
  'header.menu.contact': 'Liên hệ',
  'header.menu.support': 'Hỗ trợ',
  'header.menu.faq': 'Hỏi đáp',
  'header.menu.terms': 'Điều khoản sử dụng',
  'header.menu.privacy': 'Quyền riêng tư',
  'header.menu.security': 'Bảo mật',
}